module.exports = __webpack_public_path__ + "static/media/loading1.c547c2f7.svg";